import { render, staticRenderFns } from "./Modifier_report2.vue?vue&type=template&id=c746ef6e&scoped=true&"
import script from "./Modifier_report2.vue?vue&type=script&lang=js&"
export * from "./Modifier_report2.vue?vue&type=script&lang=js&"
import style0 from "./Modifier_report2.vue?vue&type=style&index=0&id=c746ef6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c746ef6e",
  null
  
)

export default component.exports